/**
 * Group notifications into TODAY / EARLIER and action vs updates buckets.
 */

import dayjs from "dayjs";
import { isActionRequired } from "./taxonomy.js";

const startOfToday = () => dayjs().startOf("day");

/**
 * @param {Array} notifications
 * @returns {{ todayAction: Array, todayUpdates: Array, earlier: Array }}
 */
export const groupNotificationsForFeed = (notifications = []) => {
  const todayStart = startOfToday();
  const todayAction = [];
  const todayUpdates = [];
  const earlier = [];

  for (const notification of notifications) {
    const created = dayjs(notification.created_at);
    const isToday = created.isAfter(todayStart) || created.isSame(todayStart);

    if (!isToday) {
      earlier.push(notification);
      continue;
    }

    if (isActionRequired(notification)) {
      todayAction.push(notification);
    } else {
      todayUpdates.push(notification);
    }
  }

  return { todayAction, todayUpdates, earlier };
};

/**
 * Summarize earlier notifications by category for compact cards.
 * @param {Array} notifications
 * @param {(n: Object) => string} resolveCategory
 * @returns {Array<{ category: string, count: number }>}
 */
export const summarizeEarlierByCategory = (
  notifications = [],
  resolveCategory
) => {
  const counts = {};
  for (const n of notifications) {
    const category = resolveCategory(n);
    counts[category] = (counts[category] || 0) + 1;
  }
  return Object.entries(counts)
    .map(([category, count]) => ({ category, count }))
    .sort((a, b) => b.count - a.count);
};
